import { CheckboxField, PhoneNumberField, SliderField, TextAreaField, TextField } from './fields'
import FormWrapper from './form-wrapper'

export default function SettingsForm(props) {
    const handleCheckboxChange = (field, subField, value, setValues) => {
        setValues((prev) => ({
            ...prev,
            defaultPermissions: {
                ...prev.defaultPermissions,
                [field]: {
                    ...prev.defaultPermissions?.[field],
                    [subField]: value,
                },
            },
        }))
    }

    return (
        <div>
            <FormWrapper url='app/profile' noStyle={true} noId={true} buttonText={'Save'} {...props} callback={() => window.location.reload()} enableButtonOnChange={true}>
                {(values, setValues) => (
                    <div className='flex flex-col space-y-10 divide-y'>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextField label='First Name' value={values.name} onChange={(val) => setValues({ ...values, name: val })} />
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.name?.showAlways} onChange={(val) => handleCheckboxChange('name', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.name?.showWhenLost} onChange={(val) => handleCheckboxChange('name', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextField label='Last Name' value={values.lastName} onChange={(val) => setValues({ ...values, lastName: val })} />
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.lastName?.showAlways} onChange={(val) => handleCheckboxChange('lastName', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.lastName?.showWhenLost} onChange={(val) => handleCheckboxChange('lastName', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextField type='email' required label='Email' value={values.email} onChange={(val) => setValues({ ...values, email: val })} />
                                {values.tempEmail && <div>Email change to {values.tempEmail} in progress. Check your email to confirm this change.</div>}
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.email?.showAlways} onChange={(val) => handleCheckboxChange('email', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.email?.showWhenLost} onChange={(val) => handleCheckboxChange('email', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextField label='Phone Number' value={values.phoneNumber} onChange={(val) => setValues({ ...values, phoneNumber: val })} />
                                <p className='text-sm text-gray-500'>Mobile numbers should include a country code (e.g. +44)</p>
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.phoneNumber?.showAlways} onChange={(val) => handleCheckboxChange('phoneNumber', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.phoneNumber?.showWhenLost} onChange={(val) => handleCheckboxChange('phoneNumber', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextField label='WhatsApp' placeholder='+1234567890' value={values.whatsappNumber} onChange={(val) => setValues({ ...values, whatsappNumber: val })} />
                                <p className='text-sm text-gray-500'>Mobile numbers should include a country code (e.g. +44)</p>
                                <button type='button' className='px-3 py-1 mt-2 text-xs text-gray-700 bg-gray-100 rounded hover:bg-gray-200' onClick={() => setValues({ ...values, whatsappNumber: values.phoneNumber })}>
                                    Use same as phone number
                                </button>
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.whatsappNumber?.showAlways} onChange={(val) => handleCheckboxChange('whatsappNumber', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.whatsappNumber?.showWhenLost} onChange={(val) => handleCheckboxChange('whatsappNumber', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                        <div className='pt-5'>
                            <div className='mb-3 text-lg font-medium text-neutral-800'>Notification Preferences</div>
                            <div className='mb-4 text-sm text-gray-600'>{values.subscriptionType === 'standard' ? 'Email notifications are mandatory for all users. Upgrade to Plus for WhatsApp notifications.' : 'Choose how you want to be notified when your items are found.'}</div>
                            <div className='space-y-3'>
                                <div className='flex items-center space-x-2'>
                                    <CheckboxField
                                        label='Email notifications (Required)'
                                        value={true}
                                        onChange={() => {}} // Email is now mandatory
                                        disabled={true}
                                    />
                                    <span className='text-xs text-gray-500'>Always enabled</span>
                                </div>

                                {(values.subscriptionType === 'standard_premium' || values.subscriptionType === 'family_premium') && <CheckboxField label='WhatsApp notifications (Plus Feature)' value={values.notificationPreferences?.whatsapp} onChange={(val) => setValues({ ...values, notificationPreferences: { ...values.notificationPreferences, whatsapp: val } })} />}

                                {values.subscriptionType === 'standard' && (
                                    <div className='p-3 bg-blue-50 rounded-md border border-blue-200'>
                                        <p className='text-sm text-blue-800'>
                                            <strong>Plus Benefits:</strong> Upgrade to Plus for WhatsApp notifications and enhanced features!
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {values.subscriptionType === 'family_premium' && (
                            <div className='pt-5'>
                                <div className='mb-3 text-lg font-medium text-neutral-800'>Family Plus Contacts</div>
                                <div className='mb-4 text-sm text-gray-600'>Add up to 3 additional email addresses and WhatsApp numbers for family members. You can control which contacts get notified for each item.</div>

                                <div className='space-y-4'>
                                    <div>
                                        <h4 className='mb-2 font-medium text-neutral-700'>Additional Email Addresses</h4>
                                        {[0, 1, 2].map((index) => (
                                            <div key={`email-${index}`} className='mb-2'>
                                                <TextField
                                                    label={`Email ${index + 1}`}
                                                    placeholder='family@example.com'
                                                    value={values.additionalEmails?.[index] || ''}
                                                    onChange={(val) => {
                                                        const newEmails = [...(values.additionalEmails || [])]
                                                        newEmails[index] = val
                                                        setValues({ ...values, additionalEmails: newEmails })
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    <div>
                                        <h4 className='mb-2 font-medium text-neutral-700'>Additional WhatsApp Numbers</h4>
                                        <p className='text-sm text-gray-500'>Mobile numbers should include a country code (e.g. +44)</p>
                                        {[0, 1, 2].map((index) => (
                                            <div key={`whatsapp-${index}`} className='mb-2'>
                                                <TextField
                                                    label={`WhatsApp ${index + 1}`}
                                                    placeholder='+44XXXXXXXXX'
                                                    value={values.additionalWhatsappNumbers?.[index] || ''}
                                                    onChange={(val) => {
                                                        const newNumbers = [...(values.additionalWhatsappNumbers || [])]
                                                        newNumbers[index] = val
                                                        setValues({ ...values, additionalWhatsappNumbers: newNumbers })
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className='pt-5'>
                            <div className='mb-3 text-lg font-medium text-neutral-800'>Finder Communication</div>
                            <div className='mb-4 text-sm text-gray-600'>{values.subscriptionType === 'standard' ? 'Upgrade to Plus for GPS location sharing and masked phone calls.' : 'Control how finders can communicate with you.'}</div>
                            <div className='space-y-3'>
                                <CheckboxField label='Allow finder to share GPS location (Plus Feature)' value={values.allowFinderGPS !== false} onChange={(val) => setValues({ ...values, allowFinderGPS: val })} disabled={values.subscriptionType === 'standard'} />

                                <CheckboxField label='Allow masked phone calls (Plus Feature)' value={values.allowMaskedCalls !== false} onChange={(val) => setValues({ ...values, allowMaskedCalls: val })} disabled={values.subscriptionType === 'standard'} />

                                {values.subscriptionType === 'standard' && (
                                    <div className='p-3 bg-blue-50 rounded-md border border-blue-200'>
                                        <p className='text-sm text-blue-800'>
                                            <strong>Plus Benefits:</strong> Upgrade to Plus for GPS location sharing and masked phone calls!
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='flex space-x-5'>
                            <div className='flex-1'>
                                <TextAreaField label='Default Return Instructions' value={values.defaultReturnInstructions} onChange={(val) => setValues({ ...values, defaultReturnInstructions: val })} />
                            </div>
                            <div>
                                <SliderField label='Show always' value={values.defaultPermissions?.returnInstructions?.showAlways} onChange={(val) => handleCheckboxChange('returnInstructions', 'showAlways', val, setValues)} />
                                <SliderField label='Show when lost' value={values.defaultPermissions?.returnInstructions?.showWhenLost} onChange={(val) => handleCheckboxChange('returnInstructions', 'showWhenLost', val, setValues)} />
                            </div>
                        </div>
                    </div>
                )}
            </FormWrapper>
        </div>
    )
}
